// extracted by mini-css-extract-plugin
export default {"button":"kpEv_8drjOIzn0zucXku"};